import { render, staticRenderFns } from "./m-article-video.vue?vue&type=template&id=7bfb30de"
import script from "./m-article-video.vue?vue&type=script&lang=js"
export * from "./m-article-video.vue?vue&type=script&lang=js"
import style0 from "./m-article-video.vue?vue&type=style&index=0&id=7bfb30de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports